/* eslint-disable @mews/no-custom-colors-fonts */
export const FONT_FAMILY_INTER =
    "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, sans-serif";

// @font-face definition, currently used only in PCI proxy inputs where fonts cannot be loaded from CDN because of security reasons
export const FONT_FACE_STYLES = {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    src: "url('inter-latin.woff2') format('woff2')",
};
